// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /results/get-by-round.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeResultsGetByRoundBody,
  typeResultsGetByRoundOutput200,
} from "../../sdk/results/postResultsGetByRound";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildResultsGetByRoundQueryKey(
  payload: typeResultsGetByRoundBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  queryKeySegments.push(`contestId:${JSON.stringify(payload.contestId)}`);
  queryKeySegments.push(`roundId:${JSON.stringify(payload.roundId)}`);
  return [
    "post:results:resultsGetByRound",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeResultsGetByRoundOutput200,
    unknown,
    typeResultsGetByRoundOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useResultsGetByRound(
  payload: typeResultsGetByRoundBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildResultsGetByRoundQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postResultsGetByRound(payload),
    ...resolvedOptions,
  });
}
